<template>
    <div class="border-top font-size-12 font-size-lg-16 color-2c">
        <div class="d-flex py-4 py-lg-10 border-bottom">
            <p class="font-weight-bold mr-2 mr-lg-48 w-40px">
                지름
            </p>
            <p>
                {{diameter}}
            </p>
        </div>
        <div class="d-flex py-4 py-lg-10 border-bottom">
            <p class="font-weight-bold mr-2 mr-lg-48 w-40px">
                판두께
            </p>
            <p>
                {{weight}}
            </p>
        </div>
        <div class="d-flex py-4 py-lg-10 border-bottom">
            <p class="font-weight-bold mr-2 mr-lg-48 w-40px">
                전장
            </p>
            <p>
                {{length}}
            </p>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        diameter : {type :String, default : ""},
        weight : {type :String, default : ""},
        length : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
</style>